import * as React from "react";
import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import card_img from "../../assets/product_reviews.jpg";
import close_icon from "../../assets/profile/close_icon.png";
import toast from "react-hot-toast";
import Rating from "@mui/material/Rating";
export default function ProductReviews({ open, handleClose }) {
  //   const BASE_URL = process.env.REACT_APP_BASE_URL;
  const handleDialogClose = () => {
    handleClose();
    setForm({
      name: "",
      email: "",
      message: "",
    });

    setErrors({});
  };
  const [form, setForm] = useState({
    name: "",
    email: "",
    rating: 0,
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const collectinput = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    // remove error while typing
    setErrors({ ...errors, [e.target.name]: "" });
  };
  const validateForm = () => {
    let newErrors = {};
    // Name validation
    if (!form.name.trim()) {
      newErrors.name = "Name is required";
    } else if (form.name.trim().length < 3) {
      newErrors.name = "Name must be at least 3 characters";
    }
    // Email validation
    if (!form.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(form.email)) {
      newErrors.email = "Invalid email address";
    }
    // Message validation
    if (!form.message.trim()) {
      newErrors.message = "Message is required";
    } else if (form.message.trim().length < 10) {
      newErrors.message = "Message must be at least 10 characters";
    }
    // Rating validation
    if (form.rating === 0) {
      newErrors.rating = "Please select a rating";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const formsubmit = async (e) => {
    e.preventDefault();
    // stop submit if validation fails
    if (!validateForm()) {
      toast.error("Please complete all required fields before submitting.");
      return;
    }
    try {
      const payload = {
        name: form.name,
        email: form.email,
        rating: form.rating,
        message: form.message,
      };
      setIsSubmitting(true);
      // const { data } = await axios.post("/contactmail", form);
      // toast.success(data.message);
      toast.success("From Submitted successfully");
      // Reset form
      setForm({
        name: "",
        email: "",
        rating: 0,
        message: "",
      });
      setErrors({});
      handleClose();
      console.log(payload);
    } catch (error) {
      toast.error("An error occurred. Please try again later.");
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <Dialog
      PaperProps={{
        sx: {
          maxWidth: "1052px",
          borderRadius: "0px",
        },
      }}
      open={open}
      onClose={handleDialogClose}
    >
      <div className="grid md:grid-cols-2 grid-cols-1 w-full">
        {/* Left image */}
        <div className="md:order-1 order-2">
          <img src={card_img} className="object-cover" alt="" />
        </div>
        {/* Right content */}
        <div className="flex flex-col  w-full relative xl:pt-16 lg:pt-10 lg:px-8 md:px-6 md:pt-2 xl:px-14 pt-6 px-6 md:pb-0 pb-3 md:order-2 order-1">
          {isSubmitting && (
            <div className="absolute top-0 left-0 z-10 w-full h-full bg-black opacity-45 " />
          )}

          <button
            onClick={handleDialogClose}
            className="top-4 right-3 absolute"
          >
            <img src={close_icon} alt="" />
          </button>
          <h3 className="xl:text-[20px] lg:text-[18px] xs:text-sm text-base sm:leading-[22px] text-[#333333] font-lexend font-semibold">
            Ratings & Feedback
          </h3>
          <form
            onSubmit={formsubmit}
            className=" flex flex-col sm:gap-4 gap-2 lg:gap-5 rounded-[10px] xl:mt-6 lg:pt-4 pt-2"
          >
            <div>
              <input
                placeholder="Name *"
                type="text"
                name="name"
                value={form.name}
                onChange={collectinput}
                className={`${errors.name ? "border-red-500" : "border-[#2a552f]"} placeholder:text-[#a2a19f] w-full border bg-transparent font-light   lg:text-lg sm:text-sm text-base xs:h-10 lg:h-[50px]  rounded-[10px]  py-2 lg:py-3 sm:px-2 px-4  placeholder:font-lexend font-lexend outline-none focus:border-[#2a552f]`}
              />
            </div>
            <div>
              <input
                placeholder="Email Address *"
                name="email"
                value={form.email}
                onChange={collectinput}
                type="email"
                className={`${errors.email ? "border-red-500" : "border-[#2a552f]"} placeholder:text-[#a2a19f] w-full border bg-transparent font-light   lg:text-lg sm:text-sm text-base xs:h-10 lg:h-[50px]  rounded-[10px]  py-2 lg:py-3 sm:px-2 px-4  placeholder:font-lexend font-lexend outline-none focus:border-[#2a552f]`}
              />
            </div>
            <div className="flex sm:flex-col flex-row sm:items-start items-center sm:gap-2  gap-4">
              <span
                className={`${errors.rating ? "text-red-500" : "text-[#2a552f]"} block sm:text-sm lg:text-lg text-base text-[#a2a19f] font-lexend font-light lg:mb-2`}
              >
                Rate your experience *
              </span>

              <Rating
                name="rating"
                value={form.rating}
                size="large"
                onChange={(event, newValue) => {
                  setForm({
                    ...form,
                    rating: newValue,
                  });

                  setErrors({
                    ...errors,
                    rating: "",
                  });
                }}
              />
            </div>
            <div>
              {" "}
              <textarea
                placeholder="Write a review *"
                rows={3}
                name="message"
                type="text"
                value={form.message}
                onChange={collectinput}
                className={`${errors.message ? "border-red-500" : "border-[#2a552f]"} resize-none placeholder:text-[#a2a19f] w-full border bg-transparent font-light sm:text-sm  lg:text-lg text-base   rounded-[10px] sm:py-1.5 py-2 lg:py-3 sm:px-2 px-4  placeholder:font-lexend font-lexend outline-none focus:border-[#2a552f]`}
              />
            </div>
            <div className="flex justify-end">
              <button
                disabled={isSubmitting}
                className="text-[#f4e390] bg-[#2a552f] text-base font-semibold uppercase lg:text-[22px] font-lexend xs:py-1.5 py-2 lg:py-3 text-center rounded-lg lg:w-[144px] w-28"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </Dialog>
  );
}
